import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom'; 
import { Box, Button, Typography, Link, TextField, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, List, ListItem, ListItemAvatar, ListItemText, Avatar } from '@mui/material';
import Pagination from "@mui/material/Pagination";
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

function SupremeCourtCasesPage() {
  const history = useHistory(); 
  const location = useLocation();
  const [cases, setCases] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [voteType, setVoteType] = useState(null);
  const [comment, setComment] = useState("");
  const [activePostId, setActivePostId] = useState(null);

  const [undoDialogOpen, setUndoDialogOpen] = useState(false);
  const [pendingUndoCaseId, setPendingUndoCaseId] = useState(null);
  const [pendingUndoScotusCase, setPendingUndoScotusCase] = useState(null);

  const [openVotersDialog, setOpenVotersDialog] = useState(false);
  const [activeVoters, setActiveVoters] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");

  const [sortMode, setSortMode] = useState("recent"); // default
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [initialLoading, setInitialLoading] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const [loggedInUser, setLoggedInUser] = useState(null);
  useEffect(() => {
        axios.get("/user/me")
            .then(res => setLoggedInUser(res.data))
            .catch(() => setLoggedInUser(null));
    }, []);

  /*useEffect(() => {
    axios.get('/gov/supremeCourtCases')
      .then(res => setCases(res.data))
      .catch(err => console.error(err));
  }, []);*/
  const fetchBills = async (pageNumber = 1, sort = sortMode) => {
    try {
        setLoading(true);
        const res = await axios.get("/gov/supremeCourtCases", {
            params: { page: pageNumber, limit: 20, sort },
        });
        setCases(res.data.bills);
        setTotalPages(res.data.totalPages);
        setPage(res.data.currentPage);
        setError("");
    } catch (err) {
        console.error(err);
        setError("Failed to fetch bills");
    } finally {
        setLoading(false);
        setInitialLoading(false);
    }
    };

    // Reset to page 1 whenever state OR sortMode changes
    useEffect(() => {
        setInitialLoading(true);
        setPage(1);
        fetchBills(1, sortMode);
    }, [sortMode]);

    // Regular page changes (pagination clicks)
    useEffect(() => {
        fetchBills(page, sortMode);
    }, [page]);

    const PAGE_JUMP = 10;

    const jumpBackward = () => {
        setPage(prev => Math.max(prev - PAGE_JUMP, 1));
    };

    const jumpForward = () => {
        setPage(prev => Math.min(prev + PAGE_JUMP, totalPages));
    };

  const toggleVote = async (scotusCaseId) => {
   try {
       const res = await axios.post(`/scotusCase/${scotusCaseId}/upvote`);
       const { upvotes, voted } = res.data;


       setCases(prevCases => {
           const updated = prevCases.map(scotusCase =>
               scotusCase._id === scotusCaseId
               ? { ...scotusCase, upvoteCount: upvotes, voted }
               : scotusCase
           );


       // Sort again after update
       //return updated.sort((a, b) => b.upvoteCount - a.upvoteCount);
       return updated;
       });
   } catch (err) {
       console.error('Error toggling vote:', err);
   }
   };

   const isSameUser = (voteUser, loggedInUserId) => {
        if (!voteUser) return false;
        return typeof voteUser === "string"
            ? voteUser === loggedInUserId
            : voteUser._id === loggedInUserId;
    };

  const toggleForPetitioner = async (scotusCaseId, commentId) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/petitioner`, {commentId});
            const { upvotes, scotusCaseVoted } = res.data;


            //setCases(prev =>
            //    prev.map(scotusCase => scotusCase._id === scotusCaseId ? { ...scotusCase, petitionerCount: upvotes, scotusCaseVoted } : scotusCase)
            //);
            setCases(prev =>
                prev.map(scotusCase =>
                    scotusCase._id === scotusCaseId
                    ? {
                        ...scotusCase,

                        // update counts (what you already did)
                        petitionerCount: upvotes,
                        //scotusCaseVoted,
                        votedScotusCase: true,
                        votedSide: "petitioner",

                        // update voter list (what UI checks)
                        /*scotusCaseVoters: [
                            ...(scotusCase.scotusCaseVoters || []),
                            loggedInUser._id,
                        ],*/
                        /*scotusCaseVoters: [
                            ...(scotusCase.scotusCaseVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],*/

                        // record petitioner vote
                        /*petitionerPowerVotes: [
                            ...(scotusCase.petitionerPowerVotes || []),
                            {
                                user: loggedInUser._id,
                                comment: commentId,
                            },
                        ],*/
                        /*petitionerPowerVotes: [
                            ...(scotusCase.petitionerPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // make sure respondentVotes does NOT contain user
                        respondentPowerVotes: (scotusCase.respondentPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),*/
                        }
                    : scotusCase
                )
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };


  const toggleForRespondent = async (scotusCaseId, commentId) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/respondent`, {commentId});
            const { upvotes, scotusCaseVoted } = res.data;


            //setCases(prev =>
            //    prev.map(scotusCase => scotusCase._id === scotusCaseId ? { ...scotusCase, respondentCount: upvotes, scotusCaseVoted } : scotusCase)
            //);
            setCases(prev =>
                prev.map(scotusCase =>
                    scotusCase._id === scotusCaseId
                    ? {
                        ...scotusCase,

                        // update counts
                        respondentCount: upvotes,
                        //scotusCaseVoted,

                        votedScotusCase: true,
                        votedSide: "respondent",

                        // update voter list
                        /*scotusCaseVoters: [
                            ...(scotusCase.scotusCaseVoters || []),
                            loggedInUser._id,
                        ],*/
                        /*scotusCaseVoters: [
                            ...(scotusCase.scotusCaseVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],*/

                        // record respondent vote
                        /*respondentPowerVotes: [
                            ...(scotusCase.respondentPowerVotes || []),
                            {
                                user: loggedInUser._id,
                                comment: commentId,
                            },
                        ],*/
                        /*respondentPowerVotes: [
                            ...(scotusCase.respondentPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // remove from petitionerVotes if present
                        petitionerPowerVotes: (scotusCase.petitionerPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),*/
                        }
                    : scotusCase
                )
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };




  const handleOpenDialog = (scotusCaseId) => {
        setActivePostId(scotusCaseId);
        setOpenDialog(true);
    };


  const handleSubmitVote = async () => {
        if (!voteType || !comment.trim() || !activePostId) {
            alert("Please choose vote type and enter a comment.");
            return;
        }


        try {
            //await axios.post(`/scotusCase/${activePostId}/comment`, { text: comment });
            const commentRes = await axios.post(
                `/scotusCase/${activePostId}/comment`,
                { text: comment }
            );

            const commentId = commentRes.data._id; 

            if (voteType === "For Petitioner") {
                await toggleForPetitioner(activePostId, commentId);
            } else {
                await toggleForRespondent(activePostId, commentId);
            }
            setOpenDialog(false);
            setComment("");
            setVoteType(null);
        } catch (err) {
            console.error(err);
        }
    };

    /*
    const handleUndoVote = async (scotusCaseId, scotusCase) => {
	    const res = await axios.post(`/scotusCase/${scotusCaseId}/undoVote`);

        const { upvotes, scotusCaseVoted } = res.data;

       if (
            scotusCase.petitionerPowerVotes?.some(
                vote => isSameUser(vote.user, loggedInUser._id)
            )
            ) {
                setCases(prev =>
                    prev.map(c =>
                    c._id === scotusCaseId
                        ? {
                            ...c,

                            // keep working count logic
                            petitionerCount: upvotes,
                            scotusCaseVoted,

                            // remove user from arrays so button updates
                            scotusCaseVoters: (c.scotusCaseVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            petitionerPowerVotes: (c.petitionerPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                        : c
                    )
                );
            } else if (
                scotusCase.respondentPowerVotes?.some(
                    vote => isSameUser(vote.user, loggedInUser._id)
                )
            ) {
                setCases(prev =>
                    prev.map(c =>
                    c._id === scotusCaseId
                        ? {
                            ...c,

                            // keep working count logic
                            respondentCount: upvotes,
                            scotusCaseVoted,

                            // remove user from arrays so button updates
                            scotusCaseVoters: (c.scotusCaseVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            respondentPowerVotes: (c.respondentPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                        : c
                    )
                );
            }
    };*/
    const handleUndoVote = async (scotusCaseId, scotusCase) => {
        try {
            const res = await axios.post(`/scotusCase/${scotusCaseId}/undoVote`);
            const { upvotes } = res.data;

            setCases(prev =>
            prev.map(c => {
                if (c._id !== scotusCaseId) return c;

                const updated = { ...c };

                if (c.votedSide === "petitioner") {
                updated.petitionerCount = upvotes;
                } else if (c.votedSide === "respondent") {
                updated.respondentCount = upvotes;
                }

                updated.votedScotusCase = false;
                updated.votedSide = null;

                return updated;
            })
            );
        } catch (err) {
            console.error(err);
        }
    };

    /*const openPetitionerVoters = (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Petitioner Votes");
        setActiveVoters(scotusCase.petitionerPowerVotes || []);
        setOpenVotersDialog(true);
    };

    const openRespondentVoters = (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Respondent Votes");
        setActiveVoters(scotusCase.respondentPowerVotes || []);
        setOpenVotersDialog(true);
    };*/
    /*
    const openPetitionerVoters = async (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Petitioner Votes");

        try {
            const res = await axios.get(`/scotusCase/${scotusCase._id}/voters?side=petitioner`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };

    const openRespondentVoters = async (e, scotusCase) => {
        e.stopPropagation();
        setDialogTitle("For Respondent Votes");

        try {
            const res = await axios.get(`/scotusCase/${scotusCase._id}/voters?side=respondent`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };*/

    const sortedCases = useMemo(() => {
        if (!cases) return [];

        const copy = [...cases];

        if (sortMode === "popular") {
            return copy.sort((a, b) => b.upvoteCount - a.upvoteCount);
        }

        // recent
        return copy.sort(
            (a, b) => new Date(b.date) - new Date(a.date)
        );
    }, [cases, sortMode]);

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const navItems = [
      { label: "Popular Opinion", path: "/Government/popular" },
      { label: "Following", path: "/Government/following" },
      { label: "Supreme Court", path: "/Government/SupremeCourt" },
      { label: "Congressional Bills", path: "/Government/CongressionalBills" },
      { label: "State Legislature Bills", path: "/Government/StateBills" },
      { label: "Elections", path: "/Government/Elections/GubernatorialElections" }
    ];

    const getButtonStyles = (path) => {
      const active = location.pathname === path;

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };

  return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/a')}
                   >
                       Popular Opinion
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/d')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        State Legislature Bills
                    </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>
            </Box>*/}
            {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item.path)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
            <Box
                sx={{
                    maxWidth: 900,        // match your case card width
                    mx: "auto",           // center container
                }}
            >
            <Box
                display="flex"
                justifyContent="flex-start"
                gap={1}
                mb={2}
                //sx={{ ml: 2 }}
            >
                <Button
                    size="small"
                    variant={sortMode === "popular" ? "contained" : "outlined"}
                    onClick={() => setSortMode("popular")}
                >
                    High Visibility Cases
                </Button>
                <Button
                    size="small"
                    variant={sortMode === "recent" ? "contained" : "outlined"}
                    onClick={() => setSortMode("recent")}
                >
                    Recent Cases
                </Button>
            </Box>
          {sortedCases.map((scotusCase, i) => {
            const casePetitionerCount = scotusCase.petitionerCount || 0;
            const caseRespondentCount = scotusCase.respondentCount || 0;
            let votePercentage = 0;
        
            if (casePetitionerCount > caseRespondentCount) {
                votePercentage = casePetitionerCount/(casePetitionerCount+caseRespondentCount)
            } else if (caseRespondentCount > casePetitionerCount) {
                votePercentage = caseRespondentCount/(casePetitionerCount+caseRespondentCount)
            }


            let offset = 0;
            if (casePetitionerCount > caseRespondentCount) {
                offset = -votePercentage * 50; // move right
            } else if (caseRespondentCount > casePetitionerCount) {
                offset = votePercentage * 50; // move left
            }


            let tickColor = "blue"; // default at center
            if (offset > 0) {
                //tickColor = "#00c853"; // right side
                tickColor = "red"; // right side
            } else if (offset < 0) {
                tickColor = "red"; // left side
            }


            return (
            <Box
                key={i} // unique key for each list item
                onClick={() => history.push(`/scotusCase/${scotusCase._id}/comments`)}
                p={2} // padding inside box
                my={2} // vertical margin between posts
                border="1px solid #ccc" // light grey border
                borderRadius="8px" // rounded corners
                sx={{
                    position: "relative",
                    maxWidth: 900, // limit width
                    mx: "auto", // center horizontally
                    my: 2, // vertical spacing between each post
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "#f9f9f9"
                    }
                }}
            >

              {/*<Button
                  onClick={(e) => {
                      e.stopPropagation();  
                      joinVideoCall(bill._id)}
                  }
                  variant="outlined"
                  size="small"
                  sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      zIndex: 1
                  }}
              >
                  Join Voice Call
              </Button>*/}

            <Typography
                    fontWeight="bold"
                    sx={{
                        wordBreak: "break-word",
                        pr: "140px",
                        mb: 1
                    }}
                >
                    {scotusCase.name}
            </Typography>


            {/*<Box
                display="flex"
                justifyContent="center"
                sx={{
                    mb: 2,
                    //my: 1
                }}
            >
                <Button
                    variant="outlined"
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation(); 
                        handleOpenDialog(scotusCase._id)}
                    }
                    //sx={{ ml: 1 }}
                    sx={{ mr: 2.3 }}
                >
                    Vote
                </Button>
            </Box>*/}
            {/*<Box
                display="flex"
                justifyContent="center"
                sx={{ mb: 2 }}
            >
                {loggedInUser &&
                    scotusCase.scotusCaseVoters?.some(voter =>
                        voter.toString() === loggedInUser._id
                ) &&
                    scotusCase.respondentPowerVotes?.some(voter =>
                        voter.toString() === loggedInUser._id
                ) ? (
                    <Button
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ mr: 2.3 }}
                    >
                        Voted For Respondent
                    </Button>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ mr: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(scotusCase._id);
                        }}
                    >
                        Vote
                    </Button>
                )}
            </Box>*/}
            {/*<Box
                display="flex"
                justifyContent="center"
                sx={{ mb: 2 }}
            >
                {loggedInUser &&
                    scotusCase.scotusCaseVoters?.some(voter =>
                        isSameUser(voter, loggedInUser._id)
                ) ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": {
                            display: "none",
                            },
                            "&:hover .undo-btn": {
                            display: "inline-flex",
                            },
                        }}
                    >
                    {loggedInUser &&
                    scotusCase.petitionerPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ mr: 2.3 }}
                    >
                        Voted For Petitioner
                    </Button>
                    ) : loggedInUser && scotusCase.respondentPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                    ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ mr: 2.3 }}
                    >
                        Voted For Respondent
                    </Button>
                    ) : null}
                    <Button
                        className="undo-btn"
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ display: "none", mr: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            //handleUndoVote(scotusCase._id, scotusCase);
                            setPendingUndoCaseId(scotusCase._id);
                            setPendingUndoScotusCase(scotusCase);
                            setUndoDialogOpen(true);
                        }}
                    >
                        Undo Vote
                    </Button>
                </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ mr: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(scotusCase._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>*/}
            <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
                {loggedInUser && scotusCase.votedScotusCase ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": { display: "none" },
                            "&:hover .undo-btn":  { display: "inline-flex" },
                        }}
                    >
                        <Button
                            className="voted-btn"
                            variant="outlined"
                            size="small"
                            disabled
                            sx={{ mr: 2.3 }}
                        >
                            {scotusCase.votedSide === "petitioner"
                            ? "Voted For Petitioner"
                            : "Voted For Respondent"}
                        </Button>
                        <Button
                            className="undo-btn"
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ display: "none", mr: 2.3 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setPendingUndoCaseId(scotusCase._id);
                                setPendingUndoScotusCase(scotusCase);
                                setUndoDialogOpen(true);
                            }}
                        >
                            Undo Vote
                        </Button>
                    </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ mr: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(scotusCase._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>


            {/* Vote bar with tick */}
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{ mb: 2 }}
                >
                {/* For Petitioner */}
                <Typography variant="body2">For Petitioner</Typography>


                {/* Bar with tick in middle */}
                <Box
                    sx={{
                        position: "relative",
                        height: "2px",
                        backgroundColor: "#ccc",
                        width: "300px",
                        mx: 2
                    }}>
                        {/* Tick in the center */}
                        <Box sx={{
                            position: "absolute",
                            top: "-6px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: "2px",
                            height: "14px",
                            backgroundColor: "black"
                        }} />
                    
                    {/* Dynamic tick + percentage */}
                    <Box
                        sx={{
                            position: "absolute",
                            top: "-6px",
                            left: `calc(50% + ${offset}%)`,
                            transform: "translateX(-50%)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        }}
                        >
                        {/* Tick */}
                        <Box sx={{
                            width: "2px",
                            height: "14px",
                            backgroundColor: tickColor
                        }} />


                        {/* Percentage */}
                        <Typography
                            variant="caption"
                            sx={{ mt: "2px", fontSize: "0.7rem" }}
                        >
                            {(votePercentage * 100).toFixed(0)}%
                        </Typography>
                        </Box>
                    </Box>


                    {/* For Respondent */}
                    <Typography variant="body2">For Respondent</Typography>
            </Box>
              <Link
                href={scotusCase.pdfUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
            >
                View PDF
              </Link>


              {/* Upvote button & count */}
              <Box mt={2} display="flex" alignItems="center" gap={1}>
                <Button
                    size="small"
                    variant={scotusCase.voted ? "contained" : "outlined"}
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleVote(scotusCase._id)}
                    }
                >
                    ▲ {scotusCase.voted ? "Unvote" : "Upvote"}
                </Button>
                {/*<Typography variant="body2">{scotusCase.upvoteCount} Visibility Upvotes | {scotusCase.petitionerCount} For Petitioner Votes | {scotusCase.respondentCount} For Respondent Votes</Typography>*/}
                <Typography variant="body2">
                    {scotusCase.upvoteCount} Visibility Upvotes |{" "}
                    <Box
                        component="span"
                        sx={{ color: "primary.main", }}
                        //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                        //onClick={(e) => openPetitionerVoters(e, scotusCase)}
                    >
                        {scotusCase.petitionerCount} For Petitioner Votes
                    </Box>{" "}
                    |{" "}
                    <Box
                        component="span"
                        sx={{ color: "primary.main", }}
                        //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                        //onClick={(e) => openRespondentVoters(e, scotusCase)}
                    >
                        {scotusCase.respondentCount} For Respondent Votes
                    </Box>
                </Typography>
              </Box>
            </Box>
          );
        })}
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={4}
        >
            {/* jump back 10 pages */}
            <Button
                variant="outlined"
                onClick={jumpBackward}
                disabled={page <= 1}
            >
                {"<< 10"}
            </Button>

            <Pagination
                count={totalPages}
                page={page}
                onChange={(event, value) => setPage(value)}
                color="primary"
                size="large"
                siblingCount={1}
                boundaryCount={2}
                //showFirstButton
                //showLastButton
                hidePrevButton 
                hideNextButton
            />

            {/* jump forward 10 pages */}
            <Button
                variant="outlined"
                onClick={jumpForward}
                disabled={page >= totalPages}
            >
                {"10 >>"}
            </Button>
        </Box>
        </Box>
   {/* --- Dialog --- */}
           <Dialog 
            open={openDialog} 
            onClose={() => setOpenDialog(false)} 
            fullWidth
            PaperProps={{
                sx: {
                backgroundColor: "#FFFDF8",
                borderRadius: 3,
                },
            }}
            >
               <DialogTitle>Cast Your Power Vote</DialogTitle>
               <DialogContent>
                   <Box display="flex" gap={2} mb={2}>
                       <Button
                           variant={voteType === "For Petitioner" ? "contained" : "outlined"}
                           onClick={() => setVoteType("For Petitioner")}
                       >
                           For Petitioner
                       </Button>
                       <Button
                           variant={voteType === "For Respondent" ? "contained" : "outlined"}
                           onClick={() => setVoteType("For Respondent")}
                       >
                           For Respondent
                       </Button>
                   </Box>
                   <TextField
                       fullWidth
                       multiline
                       rows={3}
                       placeholder="Explain your power vote (required)"
                       value={comment}
                       onChange={(e) => setComment(e.target.value)}
                   />
               </DialogContent>
               <DialogActions>
                   <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                   <Button
                       variant="outlined"
                       onClick={handleSubmitVote}
                       disabled={!comment || !voteType}
                   >
                       Submit Power Vote
                   </Button>
               </DialogActions>
           </Dialog>

           <Dialog
                open={undoDialogOpen}
                onClose={() => setUndoDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                        px: 2,
                        py: 1.5,
                    },
                }}
                >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    Undo your vote?
                </DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ color: "text.primary" }}>
                        This will remove your vote and the vote rationale comment associated with it.
                        This action cannot be undone.
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ pb: 2, px: 3 }}>
                    <Button
                        onClick={() => setUndoDialogOpen(false)}
                        variant="outlined"
                        sx={{
                            borderColor: "#d0cfc8",
                            color: "text.primary",
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={() => {
                            handleUndoVote(pendingUndoCaseId, pendingUndoScotusCase);
                            setUndoDialogOpen(false);
                            setPendingUndoCaseId(null);
                            setPendingUndoScotusCase(null);
                        }}
                        variant="contained"
                        color="error"
                        sx={{
                            boxShadow: "none",
                        }}
                    >
                        Yes, Undo Vote
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openVotersDialog}
                onClose={() => setOpenVotersDialog(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    {dialogTitle}
                </DialogTitle>

                <DialogContent dividers>
                    {activeVoters.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No votes
                    </Typography>
                    ) : (
                    <List disablePadding>
                        {activeVoters.map(vote => (
                        <ListItem 
                            key={vote.user._id} 
                            button
                            onClick={(e) => visitProfile(e, vote.user._id)}
                            sx={{
                                px: 0,
                                borderRadius: 2,
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                '&:hover': {
                                    backgroundColor: '#FFF2CC', // subtle highlight
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}
                            >
                                {/* Left side: Avatar + user info */}
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ListItemAvatar>
                                    <Avatar src={vote.user.profileImageUrl}>
                                        {vote.user.username?.[0]}
                                    </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={`${vote.user.first_name} ${vote.user.last_name}`}
                                        secondary={`@${vote.user.username}`}
                                    />
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    Voting Power: {vote.user.tier}
                                </Typography>
                            </Box>
                        </ListItem>
                        ))}
                    </List>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenVotersDialog(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>



      {/*<ul className="space-y-3">
        {cases.map((scotusCase, i) => (
          <li key={i} className="border p-3 rounded shadow">
            <h2 className="font-semibold">{scotusCase.name}</h2>
            <div className="space-x-4">
              <a href={scotusCase.pdfUrl} target="_blank" rel="noreferrer" className="text-green-600 underline">
                View PDF
              </a>
            </div>
          </li>
        ))}
      </ul>*/}
    </div>
  );
}

export default SupremeCourtCasesPage;